export function getRequestParams() {
  // This function is anonymous, is executed immediately and
  // the return value is assigned to QueryString!
  const queryString = {}
  if (window.location.search) {
    const query = window.location.search.substring(1)
    const vars = query.split('&')
    for (let i = 0; i < vars.length; i++) {
      const pair = vars[i].split('=')
      // If first entry with this name
      if (typeof queryString[pair[0]] === 'undefined') {
        queryString[pair[0]] = decodeURIComponent(pair[1])
        // If second entry with this name
      } else if (typeof queryString[pair[0]] === 'string') {
        queryString[pair[0]] = [queryString[pair[0]], decodeURIComponent(pair[1])]
        // If third or later entry with this name
      } else {
        queryString[pair[0]].push(decodeURIComponent(pair[1]))
      }
    }
  }
  return queryString
}
